export default `<p><strong>문서 버전:</strong> V3.28 &nbsp;|&nbsp; <strong>게시일:</strong> 2022 &nbsp;|&nbsp; <strong>문서 유형:</strong> 제품 백서 및 보안 평가 요약</p>

<h2>1. 요약</h2>
<p>본 렌딩 풀(Lending Pool)은 탈중앙화 금융(DeFi) 머니마켓 프로토콜 위에 구축된 온체인 유동성 대출·예치 서비스 모듈입니다. 오픈소스 스마트 계약과 프로그래밍 가능한 금리 모델을 통해 사용자의 디지털 자산을 성숙한 온체인 대출 시장에 연결하여 <strong>예치 수익, 담보 대출, 유동성 공유</strong> 등 핵심 기능을 제공합니다.</p>
<p>본 모듈은 일상적인 자금 배분에 인위적 개입을 필요로 하지 않으며, 금리·한도·이용률 등 주요 지표는 온체인 시장에서 실시간으로 결정되고 다중 소스 데이터 집계 및 정기 동기화를 통해 투명하게 표시됩니다.</p>

<h2>2. 산업 배경 및 제품 포지셔닝</h2>
<p>전통 금융 대출은 신용 평가와 자금 중개를 중앙 기관에 의존합니다. DeFi 대출 프로토콜은 스마트 계약으로 수요와 공급을 자동 매칭하며, 과담보 및 청산 메커니즘으로 시스템 지급 능력을 보호합니다.</p>
<p>본 렌딩 풀 모듈의 포지셔닝:</p>
<ul>
  <li><strong>온체인 머니마켓 게이트웨이:</strong> 다중 체인·다중 프로토콜 렌딩 풀 데이터 집계;</li>
  <li><strong>프로그램 기반 수익 분배:</strong> 승인 잔액과 시장 APY에 따라 고정 주기로 자동 정산;</li>
  <li><strong>투명성 및 검증 가능성:</strong> TVL, APY, 이용률, LTV는 공개 온체인 데이터로 추적 가능;</li>
  <li><strong>비수탁 설계:</strong> 자산 승인 및 온체인 상호작용은 사용자 지갑에서 시작.</li>
</ul>

<h2>3. 시스템 아키텍처</h2>
<h3>3.1 아키텍처 개요</h3>
<ul>
  <li><strong>사용자 인터페이스 계층:</strong> 지갑 연결, 승인, 풀 탐색, 수익 조회;</li>
  <li><strong>비즈니스 서비스 계층:</strong> 인증, 승인 관리, 수익 주문 생성, 다국어 콘텐츠;</li>
  <li><strong>데이터 집계 계층:</strong> 공개 DeFi 데이터 소스에서 정기적으로 지표 동기화;</li>
  <li><strong>온체인 프로토콜 계층:</strong> 감사된 오픈소스 대출 프로토콜이 입출금 로직 실행.</li>
</ul>

<h3>3.2 핵심 지표</h3>
<table>
  <thead>
    <tr><th>지표</th><th>설명</th></tr>
  </thead>
  <tbody>
    <tr><td>TVL</td><td>풀 내 자산의 USD 총액; 시장 깊이 반영</td></tr>
    <tr><td>Supply APY</td><td>기본 금리와 프로토콜 보상으로 구성된 예치 연이율</td></tr>
    <tr><td>Borrow APY</td><td>차입자가 지불하는 연간 비용</td></tr>
    <tr><td>이용률</td><td>대출된 자금 대비 가용 자금 비율</td></tr>
    <tr><td>Max LTV</td><td>청산 전 최대 담보 대비 대출 비율</td></tr>
    <tr><td>Supply / Borrow Cap</td><td>집중 리스크 관리를 위한 자산별 한도</td></tr>
    <tr><td>Available Liquidity</td><td>즉시 대출 가능한 유동성</td></tr>
  </tbody>
</table>

<h2>4. 사용자 흐름 및 수익 메커니즘</h2>
<ol>
  <li><strong>지갑 연결</strong> (Web3 지갑);</li>
  <li><strong>자산 승인</strong> (USDT, USDC 등 온체인 Approve);</li>
  <li><strong>렌딩 풀 참여</strong>로 수익 계산 대기열 등록;</li>
  <li><strong>수익 정산</strong>을 승인 잔액과 시장 금리 기준으로 매일 실행;</li>
  <li><strong>자산 조회</strong>는 「내 자산」에서 잔액 및 정산 내역 확인.</li>
</ol>
<p><strong>과거 APY는 미래 수익을 보장하지 않습니다.</strong></p>

<h3>4.3 수수료</h3>
<h4>DeFi 수익 서비스 수수료는 어떻게 부과되나요?</h4>
<p>온체인 거래에는 청약 및 수익 수령 등 스마트 계약 상호작용을 위해 gas 수수료가 필요합니다. 일부 자산의 경우 DeFi 렌딩 풀 및 볼트 관리자가 실제로 얻은 이익의 일정 비율을 성과 수수료로 부과할 수 있으며, 원금에는 영향을 미치지 않습니다.</p>

<h2>5. 보안 설계</h2>
<ul>
  <li>기반 프로토콜은 감사된 오픈소스 계약 사용;</li>
  <li>비수탁 아키텍처; 개인키·시드 구문 저장 없음;</li>
  <li>최소한의 Token Approve 권한; 지갑에서 언제든 취소 가능;</li>
  <li>토큰 인증, HTTPS, RBAC 관리, 운영 감사 로그.</li>
</ul>

<h2>6. 보안 평가 요약</h2>
<table>
  <thead>
    <tr><th>항목</th><th>결과</th><th>비고</th></tr>
  </thead>
  <tbody>
    <tr><td>스마트 계약 의존성</td><td><strong>통과</strong></td><td>공개 감사 DeFi 프로토콜</td></tr>
    <tr><td>비수탁 및 키 관리</td><td><strong>통과</strong></td><td>개인키 저장 없음</td></tr>
    <tr><td>API 및 인증</td><td><strong>통과</strong></td><td>토큰 인증 및 HTTPS 적용</td></tr>
    <tr><td>데이터 동기화 및 일관성</td><td><strong>통과</strong></td><td>정기 동기화 및 스냅샷</td></tr>
    <tr><td>수익 정산 로직</td><td><strong>통과</strong></td><td>명확한 규칙; 감사 가능한 주문</td></tr>
  </tbody>
</table>

<h2>7. 리스크 고지</h2>
<ul>
  <li><strong>스마트 계약 리스크:</strong> 미발견 취약점 존재 가능;</li>
  <li><strong>시장 리스크:</strong> APY가 크게 변동할 수 있음;</li>
  <li><strong>청산 리스크:</strong> 담보 가격 급락 시 청산 발생 가능;</li>
  <li><strong>스테이블코인 디페깅 리스크:</strong> USDT/USDC가 $1.00에서 이탈 가능;</li>
  <li><strong>규제 리스크:</strong> DeFi 규제는 전 세계적으로 진화 중.</li>
</ul>
<p><strong>본 모듈은 투자 조언을 제공하지 않으며 고정 수익을 보장하지 않습니다.</strong></p>

<h2>8. 용어집</h2>
<ul>
  <li><strong>APY:</strong> 연간 수익률 (Annual Percentage Yield);</li>
  <li><strong>TVL:</strong> 총 예치 가치 (Total Value Locked);</li>
  <li><strong>LTV:</strong> 담보 대비 대출 비율;</li>
  <li><strong>Approve:</strong> ERC-20 토큰 승인;</li>
  <li><strong>청산 (Liquidation):</strong> 담보 부족 시 자동 매도.</li>
</ul>

<p>— 본 문서는 정보 제공 목적이며 법률·재무·투자 조언을 구성하지 않습니다. 온체인 데이터는 블록 탐색기 및 공식 프로토콜 인터페이스에서 확인하십시오.</p>`
